/** Focused beats in authored order, one short teaching purpose per beat. */
export const MAGNETWORKS_BEAT_PLANS = {
  "magnetworks-prelude:mw-prelude-1": [
    {
      "id": "watch",
      "title": "Meet Pip",
      "kind": "story",
      "blockIds": [
        "mw-story-video"
      ]
    }
  ],
  "magnetworks-prelude:mw-prelude-2": [
    {
      "id": "rule",
      "title": "What must stay true?",
      "kind": "predict",
      "blockIds": [
        "mw-mission-rule",
        "mw-swan-prelude",
        "mw-prelude-gate"
      ]
    }
  ],
  "magnetworks-wonder:mw-wonder-1": [
    {
      "id": "guess",
      "title": "Guess, then predict",
      "kind": "predict",
      "blockIds": [
        "mw-wonder-hook",
        "mw-meet-kit",
        "mw-first-idea",
        "mw-first-prediction",
        "mw-swan-wonder",
        "mw-wonder-gate"
      ]
    }
  ],
  "magnetworks-explore:mw-explore-1": [
    {
      "id": "try-chip",
      "title": "Try the wand without contact",
      "kind": "record",
      "blockIds": [
        "mw-chip-setup",
        "mw-chip-trial"
      ]
    }
  ],
  "magnetworks-explore:mw-explore-2": [
    {
      "id": "guess",
      "title": "Predict across the card",
      "kind": "predict",
      "blockIds": [
        "mw-card-invite",
        "mw-card-prediction"
      ]
    },
    {
      "id": "trial",
      "title": "Test the card",
      "kind": "record",
      "blockIds": [
        "mw-card-trial",
        "mw-swan-explore",
        "mw-explore-gate"
      ]
    }
  ],
  "magnetworks-understand:mw-understand-1": [
    {
      "id": "remember",
      "title": "What did you observe?",
      "kind": "review",
      "blockIds": [
        "mw-explore-recall",
        "mw-contact-claim"
      ]
    }
  ],
  "magnetworks-understand:mw-understand-2": [
    {
      "id": "predict",
      "title": "Test a closer wand?",
      "kind": "predict",
      "blockIds": [
        "mw-distance-predict",
        "mw-swan-understand",
        "mw-understand-gate"
      ]
    }
  ],
  "magnetworks-apply:mw-apply-1": [
    {
      "id": "setup",
      "title": "Inspect the actual car",
      "kind": "safety",
      "blockIds": [
        "mw-car-setup",
        "mw-car-photos",
        "mw-car-readiness"
      ]
    }
  ],
  "magnetworks-apply:mw-apply-2": [
    {
      "id": "predict",
      "title": "Which way will Pip go?",
      "kind": "predict",
      "blockIds": [
        "mw-car-predict"
      ]
    },
    {
      "id": "test",
      "title": "Do the first trial",
      "kind": "record",
      "blockIds": [
        "mw-car-trial",
        "mw-swan-apply",
        "mw-apply-gate"
      ]
    }
  ],
  "magnetworks-test-improve:mw-test-1": [
    {
      "id": "remember",
      "title": "What changed?",
      "kind": "review",
      "blockIds": [
        "mw-trial-a-recall",
        "mw-choose-change"
      ]
    }
  ],
  "magnetworks-test-improve:mw-test-2": [
    {
      "id": "predict",
      "title": "Make a fresh prediction",
      "kind": "predict",
      "blockIds": [
        "mw-second-predict",
        "mw-fair-test"
      ]
    }
  ],
  "magnetworks-test-improve:mw-test-3": [
    {
      "id": "try",
      "title": "Try or record a safe stop",
      "kind": "record",
      "blockIds": [
        "mw-second-trial"
      ]
    },
    {
      "id": "compare",
      "title": "What did you find?",
      "kind": "reflect",
      "blockIds": [
        "mw-compare-trials",
        "mw-swan-improve",
        "mw-test-improve-gate"
      ]
    }
  ],
  "magnetworks-explain:mw-explain-1": [
    {
      "id": "reason",
      "title": "What did YOU discover?",
      "kind": "explain",
      "blockIds": [
        "mw-evidence-a-b",
        "mw-first-explanation"
      ]
    }
  ],
  "magnetworks-explain:mw-explain-2": [
    {
      "id": "movie",
      "title": "Watch why Pip moved",
      "kind": "story",
      "blockIds": [
        "mw-science-video"
      ]
    },
    {
      "id": "field",
      "title": "Look at the 3D iron filings",
      "kind": "inspect",
      "blockIds": [
        "mw-fields-pwo"
      ]
    }
  ],
  "magnetworks-explain:mw-explain-3": [
    {
      "id": "reflect",
      "title": "Does your first idea still fit?",
      "kind": "reflect",
      "blockIds": [
        "mw-after-media",
        "mw-swan-explain",
        "mw-explain-gate"
      ]
    }
  ],
  "magnetworks-reflect:mw-reflect-1": [
    {
      "id": "reflect",
      "title": "How did you investigate?",
      "kind": "reflect",
      "blockIds": [
        "mw-original-prediction",
        "mw-reflection",
        "mw-science-habit",
        "mw-swan-reflect",
        "mw-reflect-gate"
      ]
    }
  ],
  "magnetworks-grow:mw-grow-1": [
    {
      "id": "guess",
      "title": "Predict the new mystery",
      "kind": "predict",
      "blockIds": [
        "mw-floating-story",
        "mw-float-intro-photo",
        "mw-float-prediction"
      ]
    },
    {
      "id": "trial",
      "title": "Try then compare with the example",
      "kind": "record",
      "blockIds": [
        "mw-float-trial",
        "mw-float-photos"
      ]
    },
    {
      "id": "reason",
      "title": "What might hold them apart?",
      "kind": "reflect",
      "blockIds": [
        "mw-floating-link",
        "mw-swan-grow",
        "mw-grow-gate"
      ]
    }
  ],
  "magnetworks-grow:mw-grow-2": [
    {
      "id": "bonus",
      "title": "Optional motor model",
      "kind": "inspect",
      "blockIds": [
        "mw-bonus-motor-story",
        "mw-motor-pwo"
      ]
    },
    {
      "id": "next",
      "title": "Choose a next question",
      "kind": "grow",
      "blockIds": [
        "mw-next-adventure"
      ]
    }
  ]
};
